import type { ActionContext } from "vuex";
import type { RootState } from "@/store";
import { $http } from "@/utils/https";
import axios from "axios";
import type { Product } from "@/types/shop";

interface State {
    partners: any;
}

const state: State = {
    partners: null,
}

const getters = {
    partners: (state: State) => state.partners,
}

const actions = {
    GET_PARTNERS_LIST: async ({commit}: ActionContext<State, RootState>) => {
        commit('SET_PARTNERS_LIST', []);

        try {
            const response = await axios.get<{ data: Product }>(`${process.env.VUE_APP_ROOT_API}v1/pages/partners`);
            commit('SET_PARTNERS_LIST', response.data.data);
            return response.data.data;
        } catch (e) {
            throw e;
        } finally {}
    },
}

const mutations = {
    SET_PARTNERS_LIST(state: State, value: any) {
        state.partners = value;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
